import { gql } from '@apollo/client';

export const GET_AUTH_DATA = gql`
  {
    getAuthData @client {
      isLoggedIn
      loggedUser
      loggedUserID
      loggedUserAvatar
      expiresTokenIn
    }
  }
`;

export const LOGIN_USUARIO = gql`
  query loginUsuario($usuario: String!, $contrasena: String!) {
    loginUsuario(usuario: $usuario, contrasena: $contrasena) {
      usuarioId
      usuario
      avatar
      token
      expiresIn
    }
  }
`;
